import { MDBAlert, MDBBtn, MDBChip, MDBIcon, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { getMisc, getVoicemailOperator, updateGlobalSettings } from '../../../apiclients/streamsapi_bridge';
import { AddRemoveNumbers, formattedNumber, unFormatNumber } from '../../../views/popups/phonenumbers/AddRemoveNumbers';
import DeleteNumbers from '../../../views/popups/phonenumbers/DeleteNumbers';
import PopupLoaderNew from '../../../views/popups/PopupLoaderNew';
import SaveChanges from '../saveCancel';

function VoicemailOperatorSettings({setEdited}) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [freePhoneFlag, setfreePhoneFlag] = useState(true);
    const [sourceNumber, setSourceNumber] = useState([]);
    const [isdeleteNumber, setIsDeleteNumbers] = useState(false);
    const dtogglePopup = () => setIsDeleteNumbers(!isdeleteNumber);
    const [AddNumbers, setAddNumbers] = useState(false);
    const toggleNumbers = () => setAddNumbers(!AddNumbers);
    const [savedNumbers, setsavedNumbers] = useState([]);
    const [updatePHNum, setUpdatePHNum] = useState([]);
    const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
    const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [rerender, setrerender] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [users, setusers] = useState([]);
    const [groups, setgroups] = useState([]);
    const [operatorValues, setoperatorValues] = useState({});
    const [operatorNames, setoperatorNames] = useState([]);
    const [opmisc, setopmisc] = useState(false);
    const [operaValue, setoperaValue] = useState(-1)
    const addNumberRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const { register, setValue, watch, getValues, formState: { isDirty, dirtyFields, errors }, handleSubmit, reset } = useForm({
        defaultValues: {
            value: "",
            operator: 0,
        }
    });

    function handleClick() {
        addNumberRef.current.click();
    }

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    function handleChange(event) {
        event.preventDefault();
        const value = parseInt(event.target.value);
        setValue("operator", value, { shouldDirty: true });
        if (value === 1) {
            setoperatorNames(groups);
        } else if (value === 2) {
            setoperatorNames(users);

        } else {
            setoperatorNames([]);
        }

    }

    useEffect(() => {
        if (freePhoneFlag) {
            getFreePhoneNumbers();
            setfreePhoneFlag(false);
        }
    }, [freePhoneFlag]);

    const handleDelete = (number) => {
        const unformatNum = unFormatNumber(number);
        dtogglePopup();
        setUpdatePHNum([unformatNum]);
    };

    function closeSave(e) {
        reset();
    }

    useEffect(() => {
        if (opmisc) {
            getVMOperatorMisc();
            setopmisc(false);
        }

    }, [opmisc]);

    async function getVMOperatorMisc() {
        let updates = {};
        console.log(sessionStorage.getItem("admin_session"));
        updates = {
            misc: ["vm_operator"],
        };

        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            updates
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const basicInfo = await response.json();
        if (!basicInfo) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("response data is isssssss:::::::::: " + JSON.stringify(basicInfo));
        setoperatorValues(basicInfo?.misc?.vm_operator?.operator_type ?? {});
        if (operaValue !== -1) {
            if (operaValue === 1) {
                setoperatorNames(basicInfo?.misc?.vm_operator?.groups);

            } else if (operaValue === 2) {
                setoperatorNames(basicInfo?.misc?.vm_operator?.users);
            } else {
                setoperatorNames([]);
            }
        }
        console.log("user value ::::: " + JSON.stringify(basicInfo?.misc?.vm_operator?.users))
        setusers(basicInfo?.misc?.vm_operator?.users ?? []);
        setgroups(basicInfo?.misc?.vm_operator?.groups ?? []);

    }

    useEffect(() => {
        setEdited(isDirty);
        }, [isDirty])

    const onSubmit = async (data) => {
        if (isDirty) {
            const modifiedData = {};
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    modifiedData[field] = data[field];
                }

            }

            let update = {}
            if (modifiedData) {
                update = {
                    reqid: 64,
                    siteid: JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid,
                    global_settings: {
                        vm: {
                            settings: modifiedData,
                        }
                    }
                }
            }

            console.log("update vocemail operator team ::::: " + JSON.stringify(update));
            let saverep = await updateGlobalSettings(update);
            console.log("vocemail operator:::::: " + saverep);
            let saverepeMsg = await saverep.json();
            console.log("response vocemail operator::::: " + JSON.stringify(saverepeMsg))
            //alert(saverepeMsg.status);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                setSuccessMessage(saverepeMsg.message);
                setrerender(true);




            } else {
                // if (saverepeMsg.message?.errors) {
                //     saverepeMsg.message.errors.forEach((err) => {
                //         if(err.param_name === "logined_user"){
                //             props.setErrorMessage(err.message)
                //             reset();
                //         }
                //         setError(err.param_name, {
                //           type: "server",
                //           message: err.message,
                //         });
                //         const fieldElement = document.querySelector(
                //           `input[name="${err.param_name}"]`
                //         );
                //         if (fieldElement) {
                //           fieldElement.focus();
                //           //fieldElement.scrollIntoView({ behavior: "smooth" });
                //         }
                //       });
                // }


            }
        }
    }

    async function getFreePhoneNumbers() {
        let updates = {};
        console.log(sessionStorage.getItem("admin_session"));
        updates = {
            misc: ["free_dids"],
        };

        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            updates
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const basicInfo = await response.json();
        if (!basicInfo) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("response data is :::::::::: " + basicInfo);
        setSourceNumber(basicInfo.misc.free_dids);
    }

    useEffect(() => {
        if (rerender) {
            getVoiceMailOperatorDetails();
            setrerender(false);
        }
    }, [rerender]);

    async function getVoiceMailOperatorDetails() {
        try {
            setIsloading(true);
            setInternalError(false);
            const response = await getVoicemailOperator(JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid);
            const rawData = await response.json();
            console.log("voice mail operator :::::: " + JSON.stringify(rawData));
            if (response.status === 200) {
                setsavedNumbers(rawData?.vm?.dids ?? []);
                setoperaValue(rawData?.vm?.operator?.type ?? 0);
                const newValues = {
                    value: rawData?.vm?.operator?.name ?? "",
                    operator: rawData?.vm?.operator?.type ?? 0,
                }
                reset(newValues);
                setopmisc(true);

            } else if (response.status === 500) {
                setInternalError(true);
            }
            else {
                // navigate("/");
                setInternalError(true);
            }
        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        } finally {
            setIsloading(false);
        }
    }

    useEffect(() => {
        if (updatePHNum.length > 0 && updateNumbersExecuted) {
            addPhoneNumbers("add");
            setUpdateNumbersExecuted(false);
        }
    }, [updatePHNum, updateNumbersExecuted]);

    useEffect(() => {
        if (updatePHNum.length > 0 && deleteNumberFlag) {
            addPhoneNumbers("remove");
            setDeleteNumberFlag(false);
        }
    }, [updatePHNum, deleteNumberFlag]);

    async function addPhoneNumbers(fieldName) {
        let update = {
            reqid: 64,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            global_settings: {
            }
        };

        if (updatePHNum.length > 0) {
            update.global_settings = {
                vm: {
                    dids: {
                        [fieldName]: updatePHNum,
                    }
                }
            }
        }

        console.log(JSON.stringify(update));
        console.log(JSON.stringify(update));
        let saverep = await updateGlobalSettings(update);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            if (fieldName === "add") {
                setsavedNumbers((prev) => [...prev, ...updatePHNum]);
                setSuccessMessage(`Telephone Number ${updatePHNum} added successfully.`);
            } else {
                const updateAddPHNum = savedNumbers.filter(
                    (num) => !updatePHNum.includes(num)
                );
                setsavedNumbers(updateAddPHNum);
                setSuccessMessage(
                    `Telephone Number ${updatePHNum} removed successfully.`
                );
            }
        } else {
            if (fieldName === "remove") {
                const modifynum = savedNumbers.filter((num) => !updatePHNum.includes(num));
                setsavedNumbers([...modifynum, ...updatePHNum]);
            }
            // if (saverepeMsg.message?.errors) {
            //     saverepeMsg.message.errors.forEach((err) => {
            //         if (err.param_name === "logined_user") {
            //             setErrorMessage(err.message)
            //         }
            //         setError(err.param_name, {
            //             type: "server",
            //             message: err.message,
            //         });
            //         const fieldElement = document.querySelector(
            //             `input[name="${err.param_name}"]`
            //         );
            //         if (fieldElement) {
            //             fieldElement.focus();

            //         }
            //     });
            // }
        }
    }

    return (
        <>

            {/* <div className="general-settings pb-3">
                {t("Voicemail")}
            </div> */}
            <strong>Voicemail Settings</strong>
            <div>
                <div className="add-numbermain">
                    <div className="tel-numbers">
                        {t("OperatorType")}
                    </div>
                    <div className='w-30'>
                        <select
                            className="form-control form-select selectname w-100"
                            name="San Jose"
                            value={watch("operator")}
                            onChange={(e) => handleChange(e)}
                        >
                            {Object.keys(operatorValues).length > 0 &&
                                Object.entries(operatorValues).map(([key, value]) => (
                                    <option value={key}>{value}</option>
                                ))}
                        </select>
                    </div>
                </div>
                <div className="add-numbermain">
                    <div className="tel-numbers">
                        {t("Operatorname")}
                    </div>
                    <div className='w-30'>
                        <select
                            className="form-control form-select selectname w-100"
                            name="San Jose"
                            {...register("value")}

                        >
                            {operatorNames && operatorNames.length > 0 && operatorNames.map((item) => (
                                <option value={item.uniqueId}>{item.title}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <p className='mt-3'>
                    <strong>Voicemail DIDs</strong>
                </p>
                <div>
                    <div>

                        <div className="add-numbermain py-2">
                            <div className="tel-numbers">
                                {t("SelectedDIDList")}
                            </div>
                            <MDBBtn
                                className="ms-2"
                                onClick={(e) => {
                                    e.preventDefault(); // Prevent the form submission
                                    toggleNumbers(); // Open the modal
                                }}
                            >
                                <MDBIcon fas icon="plus" size="sm" />{" "}
                                {t("add_Numbers")}
                            </MDBBtn>
                        </div>
                        <div className="mt-2">
                            <div className="chips chips-placeholder">
                                {savedNumbers &&
                                    savedNumbers.length > 0 &&
                                    savedNumbers.map((phone) => (
                                        <MDBChip
                                            className="m-chip d-inline py-2 px-3"
                                            label="Example label"
                                            onDelete={handleDelete}
                                            key={phone}
                                            closeIcon
                                            size="sm"
                                        >
                                            {formattedNumber(phone)}
                                        </MDBChip>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isDirty && (
                <SaveChanges
                    onClose={closeSave}
                    isdirtyFields={isDirty}
                    onSave={(e) => {
                        e.preventDefault();
                        handleSubmit(onSubmit)();
                    }}
                />
            )}
            {AddNumbers && (
                <PopupLoaderNew
                    // size="lg"
                    // className="modal-lg"
                    title={"Add Numbers"}
                    content={
                        <AddRemoveNumbers
                            selectedNum={savedNumbers}
                            setUpdatePHNum={setUpdatePHNum}
                            setUpdateNumbersExecuted={setUpdateNumbersExecuted}
                            onClose={toggleNumbers}
                            sourceNumber={sourceNumber}
                            ref={addNumberRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setAddNumbers}
                    onClose={toggleNumbers}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                />
            )}

            {isdeleteNumber && (
                <PopupLoaderNew
                    title={"Remove Phone Number"}
                    content={
                        <DeleteNumbers
                            onClose={dtogglePopup}
                            setDeleteNumberFlag={setDeleteNumberFlag}
                            ref={addNumberRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setIsDeleteNumbers}
                    onClose={dtogglePopup}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner
                                size="sm"
                                role="status"
                                tag="span"
                                className="me-2"
                            />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}
            {successMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{successMessage}</span>
                </MDBAlert>
            )}

        </>
    )
}

export default VoicemailOperatorSettings
